import React, { useContext } from 'react';
import AnsweringServiceContext, {
  AnsweringServiceSubscribeStep,
} from './AnsweringServiceContext';
import LearnMore from './LearnMore';
import PaymentConfirmation from './PaymentConfirmation';
import SubscriptionSuccess from './SubscriptionSuccess';
import { StyledBodyPane } from './StyledComponents';
import ManageListings from './ManageListings';

/**
 * The main UI page, wrapped by the Answering Service Context,
 * to house the content for the user managing their Answering Service.
 * Displays different content depending on how far along they are in the
 * subscription process.
 */
const AnsweringServiceLayout: React.FC = () => {
  const { currentStep } = useContext(AnsweringServiceContext);

  return (
    <>
      {
        // Display whichever of the four steps the user is currently on in the subscription process
        <StyledBodyPane>
          {currentStep === AnsweringServiceSubscribeStep.LearnMore && (
            <LearnMore />
          )}
          {currentStep === AnsweringServiceSubscribeStep.ManageListings && (
            <ManageListings />
          )}
          {currentStep ===
            AnsweringServiceSubscribeStep.PaymentConfirmation && (
            <PaymentConfirmation />
          )}
          {currentStep ===
            AnsweringServiceSubscribeStep.SubscriptionSuccess && (
            <SubscriptionSuccess />
          )}
        </StyledBodyPane>
      }
    </>
  );
};

export default AnsweringServiceLayout;
